import React, { useEffect, useRef, useState } from 'react';
import './cohort-users.styles.scss';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '@/components/back-button/back-button.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faMagnifyingGlass, faUserTie } from '@fortawesome/free-solid-svg-icons';
import ThreeDotsLoader from '@/components/SHARED/loader/three-dots-loader.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import { ModalAlert } from '@/components/SHARED/modal/modal.component';

const CohortManageAdmin = ({
    users,
    cohorts
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const { cohortPath } = useParams();
    const [ selectedCohort, setSelectedCohort ] = useState(null);
    const [ availableUsers, setAvailableUsers ] = useState([]);
    const [ availToDisplay, setAvailToDisplay ] = useState([]);
    const [ cohortUsers, setCohortUsers ] = useState([]);
    const [ selectedUsers, setSelectedUsers ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const cohortRef = useRef();
    const selectedRef = useRef([]);
    const approveRef = useRef();
    const navigate = useNavigate();
    const directionRef = useRef();

    useEffect(() => {
        if (!users || !cohorts || !cohortPath) return;
        let cohort = Object.values(cohorts).filter(c => c.path === cohortPath)[0];
        cohortRef.current = cohort;
        setSelectedCohort(cohortRef.current);
        
    }, [users, cohorts, cohortPath])

    useEffect(() => {
        if (!selectedCohort) return;
        const avail = Object.values(users)
            .filter(u => 
                u.status === 'active' &&
                !selectedCohort.adminList.includes(u.cst_key)
            ).sort((a, b) => 
                a.lName.toLowerCase() > b.lName.toLowerCase() 
                ? 1 
                : (
                    a.lName.toLowerCase() === b.lName.toLowerCase()
                    ? (
                        a.fName.toLowerCase() > b.fName.toLowerCase() 
                        ? 1 
                        : -1
                    )
                    : -1 
                )
            )
        setAvailableUsers(avail);
        setAvailToDisplay(avail);
        setCohortUsers(
            Object.values(users)
            .filter(u => 
                u.status === 'active' &&
                selectedCohort.adminList.includes(u.cst_key)
            ).sort((a, b) => 
                a.lName.toLowerCase() > b.lName.toLowerCase() 
                ? 1 
                : (
                    a.lName.toLowerCase() === b.lName.toLowerCase()
                    ? (
                        a.fName.toLowerCase() > b.fName.toLowerCase() 
                        ? 1 
                        : -1
                    )
                    : -1 
                )
            )
        )
    }, [selectedCohort])

    function searchPeople(text) {
        if (!text) {
            setAvailToDisplay([...availableUsers]);
            return;
        }
        let avail = [...availableUsers]
            .filter(u => 
                u.status === 'active' &&
                (
                    u.fName.toLowerCase().includes(text.toLowerCase()) ||
                    u.lName.toLowerCase().includes(text.toLowerCase())
                )
            )
            .sort((a, b) => 
                a.lName.toLowerCase() > b.lName.toLowerCase() 
                ? 1 
                : (
                    a.lName.toLowerCase() === b.lName.toLowerCase()
                    ? (
                        a.fName.toLowerCase() > b.fName.toLowerCase() 
                        ? 1 
                        : -1
                    )
                    : -1 
                )
            )
        setAvailToDisplay(avail);
    }

    function toggleUserToSelectedList(dir, cst_key) {
        let tempArr = [...selectedRef.current];
        console.log(directionRef.current);
        if (dir !== directionRef.current) {
            directionRef.current = dir;
            tempArr = [];
        }
        if (!tempArr.includes(cst_key)) {
            tempArr.push(cst_key);
        } else {
            tempArr.splice(tempArr.indexOf(cst_key), 1)
        }
        selectedRef.current = [...tempArr];
        setSelectedUsers(selectedRef.current);
    }

    function moveUsers(e) {
        if (e !== directionRef.current) return;
        console.log(e);
        let tempCohort = {...selectedCohort};
        let tempAdminList = [...tempCohort.adminList];
            
        if (e === 'add') {
            tempAdminList = [
                ...tempAdminList,
                ...selectedRef.current
            ]
            
        } else {
            for (let u of selectedRef.current) {
                tempAdminList.splice(tempAdminList.indexOf(u), 1);
            }
        }
        tempCohort.adminList = tempAdminList;
        cohortRef.current = {...tempCohort};
        setSelectedCohort(cohortRef.current);
        console.log(tempCohort);
        selectedRef.current = [];
        setSelectedUsers(selectedRef.current);
        directionRef.current = null;
        document.getElementById('search-input').value = '';
    }

    async function handleSubmit() {
        setLoading(true);
        let tempCohort = {...cohortRef.current};
        tempCohort.ts = new Date().getTime();
        const res = await UseCloudFunction(
            'saveCohort',
            {
                'cohort': tempCohort,
                'cst_key': userProfile.cst_key
            }
        )
        console.log(res);
        setLoading(false);
        if (res.error) {
            setAlertMessage(`Something went wrong. Please try again later. (Error: ${res.error})`);
            return;
        }   
        setAlertMessage('Admin saved successfully!');
        approveRef.current = () => {
            navigate(-1);
        }
    }

    return (
        <div className='cohort-users'>
            <BackButton cancel={() => navigate(-1)} />
            <div className='section-title with-left-icon'>
                <FontAwesomeIcon icon={faUserTie} />
                Manage Cohort Administrators
            </div>
            <hr />
            <div className="cohort-users-grid">
                <div className='users-left-col'>
                    <div>
                        Choose user(s)
                    </div>
                    <div className="g-space-0-5"></div>
                    <div className='g-list-item'>
                        <div className='search-bar small'>
                            <div className='field small'>
                                <input 
                                    text='text'
                                    id='search-input' 
                                    onChange={(e) => searchPeople(e.target.value)} />
                            </div>
                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                        </div>
                        <div className="g-space-0-5"></div>
                        <div className='available-list-box'>
                            {
                                (availToDisplay) &&
                                availToDisplay
                                .map(u => {
                                    return (
                                        <button 
                                            key={u.cst_key}
                                            className={`g-button text-only available-user-item ${
                                                selectedUsers.includes(u.cst_key) 
                                                ? 'primary' 
                                                : ''
                                            }`}
                                            onClick={() => toggleUserToSelectedList('add', u.cst_key)} >
                                            {u.lName}, {u.fName}
                                        </button>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className='users-center-col'>
                    <button 
                        className='g-button med-btn'
                        onClick={() => moveUsers('add')}>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                    <button 
                        className='g-button med-btn'
                        onClick={() => moveUsers('remove')}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                </div>
                <div className='users-right-col'>
                    <div>
                        Selected Users
                    </div>
                    <div className="g-space-0-5"></div>
                    <div className='g-list-item selected-list-box'>
                        {
                            (cohortUsers) &&
                            cohortUsers
                            .map(u => {
                                return (
                                    <button 
                                        key={u.cst_key}
                                        className={`g-button text-only available-user-item ${
                                            selectedUsers.includes(u.cst_key) 
                                            ? 'primary' 
                                            : ''
                                        }`}
                                        onClick={() => toggleUserToSelectedList('remove', u.cst_key)} >
                                        {u.lName}, {u.fName}
                                    </button>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className="g-space-2"></div>
            <div className='buttons'>
                {
                    (loading)
                    ?
                    <>
                    <button className='g-button'>Cancel</button>
                    <button className='g-button'><ThreeDotsLoader /></button>
                    </>
                    :
                    <>
                    <button 
                        className='g-button'
                        onClick={() => navigate(-1)}>
                        Cancel
                    </button>
                    <button 
                        className='g-button primary'
                        onClick={() => handleSubmit()}>
                        Save Changes
                    </button>
                    </>
                }
            </div>
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage}
                onApprove={approveRef.current} />
        </div>
    )
}

export default CohortManageAdmin